import {LoggerAppenderConfig} from '../logger-appender-config';

/**
 * Console appender config
 */
export class ConsoleAppenderConfig extends LoggerAppenderConfig {
  contextSize = 0;

  /**
   * Set to true to colorize console output by levels.
   * This will make console logs easier to read.
   * Only works in Development mode.
   */
  colors: boolean = false;

  /**
   * Use native console levels, e.g. console.error, console.warn, console.debug
   */
  nativeLevels: boolean = IS_DEVELOPMENT;

  /**
   * Method of serializing objects and values passed for logging.
   *
   * Use `native` to pass the objects themselves to the console. This way has its pros and cons.
   * Pros:
   * - The browser provides its own built-in mechanism for viewing objects. Which is quite convenient.
   * - There are no problems with large or recursive objects. DOM elements are displayed well and are tied to real
   * nodes in the page inspector. Cons:
   * - This does not work well in old browsers. Some values will be visible as just `[object Object]`.
   * - DevTools will not show the state of the object that was at the time of logging, but its CURRENT state at the
   * time of observation. That is, if the link to the object remains unchanged, and something is changed in the object,
   * this will also change in the DevTools console. Which will lead to an incorrect interpretation of the log entry.
   * - If you pass objects to the logger with DevTools closed, and then open it, the passed objects may not be visible.
   *
   * Use 'string' to pass to the console a regular string from custom serializer.
   * Pros:
   * - Works well even with DevTools closed.
   * - No issues with the object state being up-to-date at the time of logging.
   * - No issues with older browsers.
   * - It is possible to customize the text color.
   * Cons:
   * - The custom serializer produces clear text, which takes up more visual space than the native object browser.
   * - Code links do not work, e.g. when viewing Errors.
   * - Limitations on serialization of large and recursive objects, such as DOM elements or Errors.
   */
  objectSerialization: 'string' | 'native' = IS_DEVELOPMENT ? 'native' : 'string';

  /**
   * Add a timestamp to each message.
   */
  timestamp?: boolean = false;
}
